<a class="btn btn-success m-btn m-btn--custom m-btn--icon" (click)="showModal()">
  <span>
    {{ 'suppliers-new.addSupplier' | transloco }}
  </span>
</a>

<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title" *ngIf="!isEdit">{{ 'suppliers-new.addSupplier' | transloco }}</h3>
    <h3 class="modal-title" *ngIf="isEdit">{{ 'suppliers-new.editingSupplier' | transloco }}</h3>
    <button class="close" type="button" (click)="modal.dismiss()">
      <span>×</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="isLoading.form">
    <div class="m-page-loader m-page-loader--non-block m-page-loader--relative">
      <div class="m-loader m-loader--brand"></div>
    </div>
  </div>

  <div class="modal-body" *ngIf="!isLoading.form">
    <form class="m-form m-form--state m-form--label-align-right" [formGroup]="supplierBank" (ngSubmit)="onSubmitForm(modal)">
      <div class="m-portlet__body" *ngIf="supplierBank">
        <div class="m-form__section m-form__section--first m-form--label-align-right">
          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-md-3 col-sm-12 is--required">
              {{ 'suppliers-new.city' | transloco }}:
            </label>
            <div class="col-lg-9 col-md-9 col-sm-12">
              <ng-select formControlName="countryId">
                <ng-option *ngFor="let c of countries" [value]="c.id">{{c.title | uiLabel}}</ng-option>
              </ng-select>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-md-3 col-sm-12 is--required">
              {{ 'suppliers-new.name' | transloco }}:
            </label>
            <div class="col-lg-9 col-md-9 col-sm-12">
              <input type="text" formControlName="name" class="form-control m-input"
                     [placeholder]="'suppliers-new.nameOrg' | transloco">
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-md-3 col-sm-12">
              {{ 'suppliers-new.description' | transloco }}:
            </label>
            <div class="col-lg-9 col-md-9 col-sm-12">
              <textarea class="form-control m-input" formControlName="description" rows="3"></textarea>
            </div>
          </div>

          <div class="form-group m-form__group row">
            <label class="col-form-label col-lg-3 col-md-3 col-sm-12 is--required">
              {{ 'suppliers-new.documents' | transloco }}:
            </label>
            <div class="col-lg-9 col-md-9 col-sm-12">
              <input type="text" formControlName="uin" class="form-control m-input" placeholder="">
            </div>
          </div>

          <app-suppliers-contract [id]="id"
                                  [countryId]="supplierBank.controls.countryId.value"></app-suppliers-contract>

          <app-representatives-new [id]="id"></app-representatives-new>

          <app-suppliers-bank [id]="id"></app-suppliers-bank>

          <app-suppliers-address [id]="id"></app-suppliers-address>
        </div>

      </div>

      <div class="modal-footer modal-footer--pad-right">
        <button type="submit" class="btn btn-success">
          {{ 'btn.save' | transloco }}
        </button>

        <button type="button" (click)="closeModal(modal)" class="btn btn-secondary">
          {{ 'btn.cancel' | transloco }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
